import React, { useContext } from 'react';

import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Box } from '@uhg-abyss/web/ui/Box';
import { useLazyGetReportsQuery } from '@src/store/services/cdb/onlineServices';
import { useLazyGetGPSReportsQuery } from '@src/store/services/gps/onlineServices';
import { getServiceURL } from '@src/env.config';
import { FileContext } from '@src/routes/Routes';
import { Table, FILL_WIDTH_COLUMNS_CSS } from '@src/common/Table';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Card } from '@uhg-abyss/web/ui/Card';
export const FieldChangeSummary = ({ fileId, isChild, setId }) => {
  const router = useRouter();
  const { service } = router.getRouteParams();
  const { fileData } = useContext(FileContext);
  const reportTypeChild = 'FC';

  const NameLink = ({ name }) => {
    const url = `${getServiceURL()}/home/help/FCH`;

    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'white' }}
      >
        {name}
      </a>
    );
  };
  const columns = React.useMemo(() => {
    return [
      {
        Header: <NameLink name="Field Type" />,
        accessor: 'fieldType',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ value }) => {
          return (
            <Box color={''}>
              <strong>{value}</strong>
            </Box>
          );
        },
      },
      {
        Header: <NameLink name="Data field" />,
        accessor: 'changeTypeTxt',
        canToggleVisibilty: false,
        isHiddenByDefault: false,
        Cell: ({ row }) => {
          return (
            <Flex
              css={{
                gap: '10px',
              }}
            >
              <Link
                href={`${
                  service === 'gps' ? '/gps' : ''
                }/home/reports/${setId}/${reportTypeChild}/${
                  row.original.changeTypeCode
                }/_/${row.original.changeTypeTxt.replace(/\//g, ' ')}`}
              >
                <Box color={''}>
                  <strong>{row.original.changeTypeTxt?.trim()}</strong>
                </Box>
              </Link>
            </Flex>
          );
        },
      },
      {
        Header: <NameLink name="Successful Count" />,
        accessor: service === 'gps' ? 'count' : 'successCount',
        canToggleVisibilty: true,
        isHiddenByDefault: false,
        Cell: ({ value }) => {
          return (
            <Box color={''}>
              <strong>{value}</strong>
            </Box>
          );
        },
      },
      ...(service === 'gps'
        ? []
        : [
            {
              Header: <NameLink name="Error Count" />,
              accessor: 'errorCount',
              canToggleVisibilty: true,
              isHiddenByDefault: false,
              Cell: ({ value }) => {
                return (
                  <Box color={''}>
                    <strong>{value}</strong>
                  </Box>
                );
              },
            },
          ]),
    ];
  }, []);

  return (
    <Card
      css={{
        'abyss-card-root': { width: '100%', padding: '0', borderRadius: '4px' },
      }}
    >
      <div
        style={{
          backgroundColor:
            'var(--abyss-colors-web-semantic-color-surface-container-primary)',
          color:
            'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
          fontSize: '18px',
          padding: '24px',
          borderTopLeftRadius: '3px',
          borderTopRightRadius: '3px',
          fontWeight: 'bold',
        }}
      >
        Field Change Summary
      </div>
      <div style={{ padding: '16px' }}>
        <Table
          columns={columns}
          dataKey="fileListTable"
          fetch={
            service === 'gps'
              ? useLazyGetGPSReportsQuery
              : useLazyGetReportsQuery
          }
          requestParams={{
            ...router.getRouteParams(),
            ...fileData,
            allDate: 'false',
          }}
          showGlobalFilter={false}
          tableCss={FILL_WIDTH_COLUMNS_CSS}
        />
      </div>
    </Card>
  );
};
